import merge from 'lodash/merge';
import xss from 'xss';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import lib from './src/lib';
import OwnComponents from './src/components';
import installElement from './src/element';
import './src/assets/icons';
import { registerTimeAgo } from './src/helpers/bootstrap';
import Package from './package.json';
import { makePhoneNumbersDialable, urlFilter } from './src/components/messages/MessageUtils';
import './src/aiq-theme/index.scss';

import 'element-plus/dist/index.css';

const Namespace = 'aiq';
const VuePropertyNamespace = `$${Namespace}`;
const OwnComponentsList = Object.keys(OwnComponents);

const components = [];

OwnComponentsList.forEach(item => {
  if (Object.prototype.hasOwnProperty.call(OwnComponents, item)) {
    const component = OwnComponents[item];
    components.push(component);
  }
});

const install = (Vue, opts = {}) => {
  // Register timeago component for frontend that installs the aiq-components.
  registerTimeAgo(Vue, opts.locale);

  if (install.installed) return;
  /* TODO: VUE3 check element-plus locale
  locale.use(opts.locale);
  locale.i18n(opts.i18n);
  */

  // Main components
  components.forEach(component => {
    // Component may be a Service or other non-Component object
    if (!component.name) {
      return;
    }

    Vue.component(component.name, component);
  });

  // Install ElementPlus
  installElement(Vue, opts);

  Vue.component('fa-icon', FontAwesomeIcon);

  Vue.config.globalProperties[VuePropertyNamespace] =
    merge(Vue.config.globalProperties[VuePropertyNamespace] || {}, lib);

  Vue.config.globalProperties[VuePropertyNamespace].confirm = (title, message, config) => {
    const defaultConfig = {
      dangerouslyUseHTMLString: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
    };
    return ElMessageBox.confirm(
      message,
      title,
      Object.assign(defaultConfig, config),
    );
  };
  Vue.config.globalProperties[VuePropertyNamespace].closeConfirm = ElMessage;
  Vue.config.globalProperties[VuePropertyNamespace].loading = ElLoading.service;

  Vue.config.globalProperties.$filters = {
    sanitize: xss,
    urlFilter,
    makePhoneNumbersDialable,
  };
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: Package.version,
  install,
};
